"use client";

import { useSyncExternalStore } from "react";

/**
 * Returns `true` only after client-side hydration is complete.
 * During SSR and the initial hydration pass, returns `false`.
 *
 * Use this to prevent dead clicks on elements that look interactive
 * but don't have event handlers attached yet (the hydration gap).
 */

const subscribe = () => () => {};
const getSnapshot = () => true;
const getServerSnapshot = () => false;

export function useHydrated(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
